import type { PaymentApiClient } from '@fourthwall/services/dist/PaymentApiClient'

import type { PaymentMethod } from '../Billing.types'

export type ChargesPaymentMethodData = Awaited<
  ReturnType<typeof PaymentApiClient.getShopCharges>
>['data']['charges'][number]['paymentMethodDetails']

export const getChargeMethod = (data: ChargesPaymentMethodData): PaymentMethod => {
  if (data.type === 'CARD') {
    return {
      type: 'CARD',
      brand: data.brand,
      last4Digits: data.last4Digits,
    }
  }

  if (data.type === 'PAYPAL') {
    return {
      type: 'PAYPAL',
      email: data.email,
    }
  }

  // UNKNOWN
  return {
    type: 'UNKNOWN',
  }
}
